import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isItemIncludedForBAP, useAppDispatch } from '../../../core/utils';
import useFetchLayoutServiceModel from '../../../core/apiHooks/useFetchLayoutServiceModel';
import { setIsLayoutServiceSkipped, setLayoutServiceHasError, setLayoutServiceIsTriggered, } from '../../../core/reducers/ui';
import { selectAllTrims } from '../../../core/apis/layoutServiceApi';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { useUserOrDefaultProvince } from '../../../utils/sitecoreContext';
/**
 * Get model data from Layout Service API
 *
 */
const useModelData = (sitecoreId, modelYear) => {
    const { modelKey } = useSelector(selectCurrentVehicle);
    const provinceCode = useUserOrDefaultProvince();
    const { trims, nameBadge, defaultTrim, isUninitialized, hasError, isFetching, isSkipped } = useFetchLayoutServiceModel(sitecoreId, modelYear);
    const dispatch = useAppDispatch();
    const allTrims = selectAllTrims(trims).filter(trim => isItemIncludedForBAP(trim, provinceCode));
    // used to handle BAP url logic
    useEffect(() => {
        dispatch(setLayoutServiceIsTriggered(!isUninitialized && !isFetching));
        if (modelKey) {
            dispatch(setIsLayoutServiceSkipped(isSkipped));
        }
        dispatch(setLayoutServiceHasError(hasError));
    }, [dispatch, hasError, isFetching, isSkipped, isUninitialized, modelKey]);
    return {
        trims: allTrims,
        nameBadge,
        defaultTrim,
        isFetching,
    };
};
export default useModelData;
